import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";

import Localization from "../../localization";
import Button from "../../components/button";
import IconClose from "../../components/icons/close";
import IconSpinner from "../../components/icons/spinner";
import IconLogo from "../../components/icons/logo";
import Gallery from "../../components/gallery";
import Image from "../../components/image";
import IconEffect1 from "../../components/icons/effect1";
import { fixExternalLinks } from "../../utils/helper";
import { loadArtist } from "../../redux/actions/artists";
import { getArtistDetails } from "../../redux/selectors/artist";

class ArtistDetails extends Component {
    componentDidMount() {
        this.props.loadArtist(this.props.match.params.slug);
    }

    render() {
        const { artist, locale, history } = this.props;

        const className =
            "fixed bottom-0 top-0 left-0 flex justify-end right-0 z-20";

        if (!artist)
            return (
                <div className={className}>
                    <Helmet>
                        <body className="modal-open" />
                    </Helmet>
                    <div className="bg-blue flex flex-col items-center justify-center w-full">
                        <IconSpinner className="animate-spin w-25 xl:w-32 h-25 xl:h-32 text-pink" />
                        <IconLogo
                            className={
                                "w-140 xl:w-208 h-30 xl:h-46 mt-40 text-pink"
                            }
                        />
                    </div>
                </div>
            );

        const website = artist.links.find(
            (item) => item.title.toLowerCase() === "website"
        );

        return (
            <div className={className}>
                <Helmet>
                    <body className="modal-open" />
                </Helmet>

                <div className="bg-blue pt-30 xl:pt-40 pb-60 px-16 xl:px-50 overflow-y-auto w-full">
                    <div className="hidden xl:flex justify-end">
                        <Button
                            icon={
                                <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-blue text-pink" />
                            }
                            backgroundColorOver={"bg-pink"}
                            borderColor={"border-pink"}
                            onClick={() => {
                                history.goBack();
                            }}
                            style={"w-70"}
                        />
                    </div>
                    <div className="flex relative xl:mt-40">
                        <div className="xl:w-4/12" />
                        <div className="xl:w-8/12 mr-60 xl:mr-0">
                            <h1 className="font-bold xl:w-9/12 text-30 xl:text-60 text-pink">
                                {artist.name}
                            </h1>
                            <div className="xl:hidden absolute right-0 top-0">
                                <Button
                                    icon={
                                        <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-blue text-pink" />
                                    }
                                    backgroundColorOver={"bg-pink"}
                                    borderColor={"border-pink"}
                                    onClick={() => {
                                        history.goBack();
                                    }}
                                    style={"w-50"}
                                />
                            </div>
                        </div>
                    </div>
                    {artist.cover && (
                        <div className="xl:hidden mt-30 w-8/12">
                            <Image
                                alt={artist.cover.alt || artist.name}
                                url={artist.cover.url}
                                aspectRatio="aspect-ratio-3/4"
                            />
                            <p className="text-center mt-10 text-pink">
                                {artist.caption}
                            </p>
                        </div>
                    )}
                    <div className="flex mt-30 xl:mt-40">
                        <div className="hidden xl:block w-3/12">
                            {artist.cover && (
                                <Image
                                    alt={artist.cover.alt || artist.name}
                                    url={artist.cover.url}
                                    aspectRatio="aspect-ratio-85/96"
                                />
                            )}
                            <p className="text-center mt-10 text-pink">
                                {artist.caption}
                            </p>
                        </div>
                        <div className="xl:w-2/12" />
                        <div className="xl:w-7/12">
                            <div
                                className="article-body bio text-17 leading-tight xl:text-23 text-pink xl:w-9/12"
                                dangerouslySetInnerHTML={{
                                    __html: fixExternalLinks(artist.bio),
                                }}
                            />
                            {website && (
                                <div className="flex mt-30 xl:mt-60">
                                    <Button
                                        text={"Website"}
                                        backgroundColorOver={"bg-pink"}
                                        borderColor={"border-pink"}
                                        textStyle={
                                            "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-blue text-pink"
                                        }
                                        href={website.url}
                                        style={"w-208"}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    {artist.gallery && artist.gallery > 0 && (
                        <div className="mt-40 xl:mt-70 flex justify-end">
                            <Gallery data={artist.gallery} />
                            <div className="xl:w-1/12" />
                        </div>
                    )}
                    <div className="flex xl:flex-row flex-col mt-40 xl:mt-120">
                        <div className="xl:w-1/12" />
                        {artist.contents.length > 0 ? (
                            <div className="xl:w-4/12">
                                <p className="font-judge font-bold mb-30 xl:mb-40 text-30 uppercase text-pink">
                                    {Localization[locale].artist.contents}
                                </p>
                                {artist.contents.map((content) => (
                                    <div className="flex mb-16">
                                        <IconEffect1
                                            className={
                                                "w-20 h-20 mr-20 text-pink"
                                            }
                                        />
                                        <a
                                            href={content.url}
                                            target="_blank"
                                            className={"text-17 text-pink"}
                                            title={content.title}
                                        >
                                            <span className="underline">
                                                {content.title}
                                            </span>
                                            {content.credits &&
                                                " (" + content.credits + ")"}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="xl:w-4/12" />
                        )}
                        <div className="xl:w-2/12 mt-40 xl:mt-0" />
                        {artist.links.filter(
                            (link) => link.title.toLowerCase() !== "website"
                        ).length > 0 && (
                            <div>
                                <p className="font-judge font-bold mb-30 xl:mb-40 text-30 uppercase text-pink">
                                    {Localization[locale].artist.social}
                                </p>
                                {artist.links
                                    .filter(
                                        (link) =>
                                            link.title.toLowerCase() !==
                                            "website"
                                    )
                                    .map((link) => (
                                        <Button
                                            text={link.title}
                                            backgroundColorOver={"bg-pink"}
                                            borderColor={"border-pink"}
                                            textStyle={
                                                "font-bold text-20 xl:text-17 z-10 transition hover-hover:group-hover:text-blue text-pink"
                                            }
                                            href={link.url}
                                            style={"w-208 mb-16"}
                                        />
                                    ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    locale: state.app.locale,
    artist: getArtistDetails(state, props.match.params.slug),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadArtist,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ArtistDetails);
